import { useCallback, useState } from "react";
import "./App.css";
import { Header, APP_VERSION } from "./components/Header";
import { TickerTable } from "./components/TickerTable";
import { TickerDetailDrawer } from "./components/TickerDetailDrawer";
import { LogsDrawer } from "./components/LogsDrawer";
import { useDashboardData } from "./hooks";

function Dashboard() {
  const {
    tickers,
    tickersError,
    loading,
    refreshing,
    lastUpdated,
    providers,
    health,
    refresh,
  } = useDashboardData();

  const [selected, setSelected] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [logsOpen, setLogsOpen] = useState(false);

  const onSelect = useCallback((ticker) => {
    setSelected(ticker);
    setDrawerOpen(true);
  }, []);

  return (
    <div className="App flex flex-col min-h-screen">
      <Header
        lastUpdated={lastUpdated}
        onRefresh={() => refresh(true)}
        isRefreshing={refreshing}
        providers={providers}
        health={health}
        onOpenLogs={() => setLogsOpen(true)}
      />

      <main className="flex-1 px-4 sm:px-6 py-4">
        <div
          className="mb-4 flex items-center gap-3 text-[10px] uppercase tracking-[0.3em] text-muted-soft"
          data-testid="status-strip"
        >
          <span className="flex items-center gap-1.5">
            <span className="inline-block w-1.5 h-1.5 bg-accent-amber" />
            S&amp;P 500 Universe
          </span>
          <span className="text-muted-soft">·</span>
          <span>
            Source <span className="text-accent-amber">slickcharts</span>
          </span>
          <span className="text-muted-soft">·</span>
          <span>
            Mode{" "}
            <span className="text-accent-amber">
              {health?.cache?.live_entries > 0 ? "live + cache" : "live"}
            </span>
          </span>
        </div>

        <div
          className="h-[calc(100vh-170px)] min-h-[480px]"
          data-testid="table-wrapper"
        >
          <TickerTable
            tickers={tickers}
            loading={loading}
            error={tickersError}
            onSelect={onSelect}
            selectedSymbol={selected?.symbol}
          />
        </div>
      </main>

      <TickerDetailDrawer
        ticker={selected}
        open={drawerOpen}
        onOpenChange={setDrawerOpen}
      />

      <LogsDrawer open={logsOpen} onOpenChange={setLogsOpen} />

      <footer
        data-testid="app-footer"
        className="border-t border-soft px-4 sm:px-6 py-3 flex items-center justify-between text-[10px] uppercase tracking-[0.3em] text-muted-soft"
      >
        <span>
          OmniMatrix<span className="text-accent-amber">·</span>Core
          <span className="ml-2 normal-case tracking-[0.15em] text-muted-soft">
            ver.&nbsp;{APP_VERSION}
          </span>
        </span>
        <span>
          {tickers
            ? `${tickers.length} components indexed`
            : "initialising…"}
        </span>
      </footer>
    </div>
  );
}

function App() {
  return <Dashboard />;
}

export default App;
